module.exports = __webpack_public_path__ + "img/smartwatch.e2592dee.svg";